import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import { FC, useState } from 'react';
import { ErrorFields } from '../admin/AdminRegistrationSteps';
import { StyledAccordianSummary, StyledAccordion, StyledAccordionDetails } from './SpeakerForm';
import SpeakerPackagesChoice from '../registration/packages/speaker/SpeakerPackagesChoice';

interface SpeakerPackagesProps {
}

const SessionsSectionUpdate: FC<SpeakerPackagesProps> = ({
}) => {

    const [expanded, setExpanded] = useState<boolean>(false);
    
    return (
        <>       
        <StyledAccordion elevation={4} onChange={() => setExpanded(c => !c)}>
            <StyledAccordianSummary 
                expandIcon={<FontAwesomeIcon fixedWidth icon={faChevronDown} color='white' />}

            >
                <Typography variant="h3" color="white"><b>Sessions</b></Typography>   
            </StyledAccordianSummary>
            <StyledAccordionDetails>
                
                <SpeakerPackagesChoice />
                        
            </StyledAccordionDetails>
        </StyledAccordion>

        {
            !expanded && (
                <ErrorFields
                    errorFields={[
                        "packageId"
                    ]}
                />
            )
        }
        <br />
        </>

    )
}

export default SessionsSectionUpdate;
